import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, makeStateKey, TransferState } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';
import { HomeApiService } from '@modules/home/home-api.service';
import { MateriaHome } from '@shared/data-structure/interfaces';
import { dataMaterias } from '@modules/home/home-data';
import { Subscription, tap } from 'rxjs';

const HOME_KEY = makeStateKey<any>('HOME');

@Component({
  selector: 'astrea-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  public loading = true;

  public books!: any[];
  public recents!: any[];
  public materias: MateriaHome[] = dataMaterias;

  private traslate$!: Subscription;

  constructor(
    private seo: SeoMetadataService,
    private api: HomeApiService,
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
    this.loadHomeData();
  }

  ngOnDestroy(): void {
    if (this.traslate$) this.traslate$.unsubscribe();
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: `Editorial Astrea`,
      description: `Bienvenido a la Editorial Astrea. Más de 50 años de trayectoria trabajando con contenido jurídico para toda Latinoamérica.`
    });
  }

  loadHomeData(): void {
    const cachedData = this.transferState.get(HOME_KEY, null);
    if (cachedData) {
      this.books = cachedData.result.data.books?.vDoctrines;
      this.recents = cachedData.result.data.recents?.vDoctrines;
      this.loading = false;
    } else {
      this.getHomeData();
    }
  }

  getHomeData(): void {
    this.api.getHomeData()
      .pipe(
        tap(data => {
          if (isPlatformServer(this.platformId)) {
            this.transferState.set(HOME_KEY, data);
          }
        })
      )
      .subscribe({
        next: res => {
          this.books = res.result.data.books?.vDoctrines;
          this.recents = res.result.data.recents?.vDoctrines;
          this.loading = false;
        }
      });
  }

}
